(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('susumu-product-details')) {
  customElements.define('susumu-product-details', class extends HTMLElement {
    connectedCallback() {
      if (!this.closest('.shopify-section--main-product')) return;
      this.groups = [...this.querySelectorAll('.accordion-group')];
      this.observer = new ResizeObserver(() => this.updateGroups());
      this.onToggle = event => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        const group = details.closest('.accordion-group');
        if (!group || !this.contains(group)) return;
        if (details.open) {
          group.querySelectorAll('details[open]').forEach(other => {
            if (other !== details) {
              other.open = false;
              other.setAttribute('aria-expanded', 'false');
            }
          });
        }
        details.setAttribute('aria-expanded', String(details.open));
        this.updateGroups();
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.groups.forEach(group => {
        group.classList.add('susumu-tabs-ready');
        group.querySelectorAll('.accordion__content, summary').forEach(element => {
          this.observer.observe(element);
        });
      });
      this.updateGroups();
    }

    updateGroups() {
      this.groups.forEach(group => {
        const headerHeight = Math.max(0, ...[...group.querySelectorAll('summary')].map(summary => summary.offsetHeight));
        const contentHeight = Math.max(0, ...[...group.querySelectorAll('details[open] .accordion__content')].map(content => content.scrollHeight));
        group.style.setProperty('--susumu-tab-header-height', `${headerHeight}px`);
        group.style.setProperty('--susumu-tab-content-height', `${contentHeight ? contentHeight + 16 : 0}px`);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.onToggle) this.removeEventListener('toggle', this.onToggle, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["susumu-curated-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('susumu-curated-look')) {
    customElements.define('susumu-curated-look', class extends HTMLElement {
      connectedCallback() {
        this.ready = this.dataset.discountReady === 'true';
        this.variantLists = new WeakMap();
        this.mainVariants = JSON.parse(this.querySelector('[data-look-main]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        });
        this.onOpen = (event) => {
          const button = event.target.closest('[data-look-open]');
          if (!button || !this.contains(button)) return;
          const dialog = document.getElementById(button.getAttribute('aria-controls'));
          if (!dialog) return;
          this.updateSelection(dialog);
        };
        this.onChange = (event) => {
          if (!event.target.matches('[data-look-option]')) return;
          const dialog = event.target.closest('[data-look-dialog]');
          if (dialog?.dataset.lookOwner !== this.dataset.mainForm) return;
          this.updateSelection(dialog);
        };
        this.onAdd = (event) => {
          const button = event.target.closest('[data-look-add]');
          const dialog = button?.closest('[data-look-dialog]');
          if (dialog?.dataset.lookOwner !== this.dataset.mainForm) return;
          this.addLook(dialog);
        };
        this.addEventListener('click', this.onOpen);
        document.addEventListener('change', this.onChange);
        document.addEventListener('click', this.onAdd);
      }

      getSelection(dialog) {
        const mainId = document.getElementById(this.dataset.mainForm)?.elements.namedItem('id')?.value;
        const mainVariant = this.mainVariants.find(variant => String(variant.id) === mainId);
        if (!this.variantLists.has(dialog)) this.variantLists.set(dialog, JSON.parse(dialog.querySelector('[data-look-variants]').textContent));
        const variants = this.variantLists.get(dialog);
        const values = [...dialog.querySelectorAll('[data-look-option]')].map(select => select.value);
        const variant = values.length ? variants.find(item => item.options.every((value, index) => value === values[index])) : variants[0];
        const complete = values.every(Boolean);
        return { mainVariant, variant, complete, valid: complete && Boolean(variant?.available && mainVariant?.available) };
      }

      updateSelection(dialog) {
        const { mainVariant, variant, complete, valid } = this.getSelection(dialog);
        dialog.querySelector('[data-look-main-variant]').textContent = mainVariant?.title === 'Default Title' ? '' : (mainVariant?.title || '');
        dialog.querySelector('[data-look-availability]').textContent = complete && (!variant?.available || !mainVariant?.available) ? this.dataset.unavailable : '';
        if (variant) dialog.querySelector('[data-look-piece-price]').textContent = this.money.format(variant.price / 100);
        dialog.querySelector('[data-look-total]').textContent = valid
          ? this.money.format((Math.round(mainVariant.price * 0.95) + Math.round(variant.price * 0.95)) / 100)
          : '—';
        const button = dialog.querySelector('[data-look-add]');
        button.disabled = !this.ready || !valid || Boolean(this.busy);
        button.setAttribute('aria-disabled', String(button.disabled));
      }

      buildItems(dialog, selection) {
        const mainProduct = this.dataset.mainProduct;
        const extraProduct = dialog.dataset.lookDialog;
        const pair = [mainProduct, extraProduct].sort((a, b) => Number(a) - Number(b)).join('-');
        if (mainProduct === extraProduct || pair !== dialog.dataset.lookPair || !(this.dataset.discountPairs || '').split(',').includes(pair)) return null;
        const mainForm = document.getElementById(this.dataset.mainForm);
        const properties = {};
        for (const [key, value] of new FormData(mainForm)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        const marker = `susumu-look-v1:${pair}:`;
        return [
          { id: selection.mainVariant.id, quantity: 1, properties: { ...properties, _susumu_look: marker + mainProduct } },
          { id: selection.variant.id, quantity: 1, properties: { _susumu_look: marker + extraProduct } }
        ];
      }

      async addLook(dialog) {
        if (!this.ready || this.busy) return;
        const selection = this.getSelection(dialog);
        if (!selection.valid) return this.updateSelection(dialog);
        const items = this.buildItems(dialog, selection);
        if (!items) return;
        const button = dialog.querySelector('[data-look-add]');
        const error = dialog.querySelector('[data-look-error]');
        const checkCart = dialog.querySelector('[data-look-check-cart]');
        error.textContent = '';
        checkCart.hidden = true;
        this.busy = true;
        this.updateSelection(dialog);
        button.setAttribute('aria-busy', 'true');
        dialog.querySelector('[data-look-availability]').textContent = this.dataset.adding;
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const requestedSections = [...new Set(sections)].slice(0, 5);
        let added = false;
        try {
          const response = await fetch(this.dataset.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items, sections: requestedSections, sections_url: window.location.pathname })
          });
          added = response.ok;
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : '');
          if (window.themeVariables?.settings?.cartType === 'page' || !requestedSections.length || requestedSections.some(id => typeof result.sections?.[id] !== 'string')) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const cartResponse = await fetch(this.dataset.cartJson);
          if (!cartResponse.ok) throw new Error('');
          const cart = await cartResponse.json();
          cart.sections = result.sections;
          await dialog.hide();
          document.getElementById(this.dataset.mainForm).dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true, detail: { items: result.items, cart, onSuccessDo: 'force_open_drawer' }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
          }));
        } catch (failure) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          error.textContent = [failure.message, this.dataset.cartError].filter(Boolean).join(' ');
          checkCart.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } finally {
          this.busy = false;
          button.removeAttribute('aria-busy');
          this.updateSelection(dialog);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onOpen);
        document.removeEventListener('change', this.onChange);
        document.removeEventListener('click', this.onAdd);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["susumu-estimated-dispatch"] && !Shopify.designMode) return;
  try {
    class SusumuEstimatedDispatch extends HTMLElement {
    connectedCallback() {
      this.updateDate();
      this.refreshTimer = window.setInterval(() => {
        if (!document.hidden) this.updateDate();
      }, 60000);
      this.visibilityHandler = () => {
        if (!document.hidden) this.updateDate();
      };
      document.addEventListener('visibilitychange', this.visibilityHandler);
    }

    disconnectedCallback() {
      window.clearInterval(this.refreshTimer);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }

    static dateAfterDays(now, days, timeZone) {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(now);
      const value = (type) => Number(parts.find((part) => part.type === type).value);
      const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      date.setUTCDate(date.getUTCDate() + days);
      return date;
    }

    updateDate() {
      const time = this.querySelector('time');
      if (!time) return;
      const date = SusumuEstimatedDispatch.dateAfterDays(new Date(), Number(this.dataset.days), this.dataset.timeZone);
      time.dateTime = date.toISOString().slice(0, 10);
      time.textContent = this.dataset.dateFormat
        .replace('%-d', String(date.getUTCDate()))
        .replace('%d', String(date.getUTCDate()).padStart(2, '0'))
        .replace('%m', String(date.getUTCMonth() + 1).padStart(2, '0'))
        .replace('%B', new Intl.DateTimeFormat(this.dataset.locale || 'en', {
          month: 'long', timeZone: 'UTC'
        }).format(date))
        .replace('%Y', String(date.getUTCFullYear()));
    }
  }

  if (!window.customElements.get('susumu-estimated-dispatch')) {
    window.customElements.define('susumu-estimated-dispatch', SusumuEstimatedDispatch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["susumu-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('susumu-size-guide')) {
    customElements.define('susumu-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.chart = this.querySelector('[data-size-chart]');
        this.quiz = this.querySelector('[data-fit-quiz]');
        this.invitation = this.querySelector('[data-fit-invitation]');
        this.result = this.querySelector('[data-fit-result]');
        this.german = this.dataset.locale === 'de';
        this.profile = this.dataset.fitProfile || 'bottom';
        this.availableSizes = (this.dataset.availableSizes || '').split('|').map(value => value.trim()).filter(Boolean);
        this.rows = Array.from(this.querySelectorAll('tbody tr[data-size]')).map(row => ({
          size: row.dataset.size,
          number: row.dataset.number,
          shoulder: row.dataset.shoulder ? Number(row.dataset.shoulder) : null,
          values: Object.fromEntries(['waist', 'hip', 'bust'].map(field => [field, {
            min: row.dataset[field + 'Min'] ? Number(row.dataset[field + 'Min']) : null,
            max: row.dataset[field + 'Max'] ? Number(row.dataset[field + 'Max']) : null
          }]))
        }));
        this.steps = Array.from(this.querySelectorAll('[data-fit-step]'));
        this.currentStep = 0;

        this.addEventListener('click', event => {
          if (event.target.closest('[data-start-fit-quiz]')) this.showQuiz();
          if (event.target.closest('[data-show-size-chart]')) this.showChart(true);

          const modeButton = event.target.closest('[data-fit-mode-button]');
          if (modeButton) this.setMode(modeButton.dataset.fitModeButton);

          if (event.target.closest('[data-fit-back]')) this.updateStep(this.currentStep - 1);
          if (event.target.closest('[data-fit-next]')) this.nextStep();
          if (event.target.closest('[data-fit-recommend="measurements"]')) this.recommendMeasurements();
          if (event.target.closest('[data-fit-restart]')) this.restartNoTapeQuiz();
        }, { signal: this.controller.signal });

        this.addEventListener('keydown', event => {
          if (event.key !== 'Enter') return;
          if (event.target.matches('[data-fit-measurement]')) {
            event.preventDefault();
            this.recommendMeasurements();
          } else if (event.target.matches('[data-fit-answer]')) {
            event.preventDefault();
            this.nextStep();
          }
        }, { signal: this.controller.signal });

        this.closest('x-modal')?.addEventListener('dialog:after-hide', () => this.showChart(false), { signal: this.controller.signal });
        this.setMode('no-tape');
      }

      disconnectedCallback() { this.controller?.abort(); }

      showQuiz() {
        if (!this.quiz) return;
        this.chart.hidden = false;
        if (this.invitation) this.invitation.hidden = true;
        this.quiz.hidden = false;
        this.result.replaceChildren();
        this.setMode('no-tape');
        this.updateStep(0);
        this.quiz.querySelector('h2').focus();
      }

      showChart(focus) {
        this.chart.hidden = false;
        if (this.invitation) this.invitation.hidden = false;
        if (this.quiz) this.quiz.hidden = true;
        if (focus) this.chart.querySelector('[data-chart-title]').focus();
      }

      setMode(mode) {
        this.mode = mode;
        this.querySelectorAll('[data-fit-mode]').forEach(section => {
          section.hidden = section.dataset.fitMode !== mode;
        });
        this.querySelectorAll('[data-fit-mode-button]').forEach(button => {
          const active = button.dataset.fitModeButton === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.result?.replaceChildren();
        if (mode === 'no-tape') this.updateStep(this.currentStep || 0);
      }

      updateStep(index) {
        if (!this.steps.length) return;
        this.currentStep = Math.max(0, Math.min(index, this.steps.length - 1));
        this.steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== this.currentStep; });
        const progressLabel = this.querySelector('[data-fit-progress-label]');
        const progressBar = this.querySelector('[data-fit-progress-bar]');
        const backButton = this.querySelector('[data-fit-back]');
        const nextButton = this.querySelector('[data-fit-next]');
        if (progressLabel) progressLabel.textContent = (this.german ? 'Frage ' : 'Question ') + (this.currentStep + 1) + (this.german ? ' von ' : ' of ') + this.steps.length;
        if (progressBar) progressBar.style.width = (((this.currentStep + 1) / this.steps.length) * 100) + '%';
        if (backButton) backButton.disabled = this.currentStep === 0;
        if (nextButton) nextButton.textContent = this.currentStep === this.steps.length - 1
          ? (this.german ? 'Empfehlung anzeigen' : 'Show recommendation')
          : (this.german ? 'Weiter' : 'Continue');
      }

      validateCurrentStep() {
        const step = this.steps[this.currentStep];
        if (!step) return false;
        const required = Array.from(step.querySelectorAll('[required]'));
        const radios = required.filter(input => input.type === 'radio');
        if (radios.length && !radios.some(input => input.checked)) {
          radios[0].setCustomValidity(this.german ? 'Bitte wählen Sie eine Antwort aus.' : 'Please choose an answer.');
          radios[0].reportValidity();
          radios[0].setCustomValidity('');
          return false;
        }
        for (const input of required.filter(input => input.type !== 'radio')) {
          if (!input.reportValidity()) return false;
        }
        return true;
      }

      nextStep() {
        if (!this.validateCurrentStep()) return;
        if (this.currentStep < this.steps.length - 1) {
          this.updateStep(this.currentStep + 1);
          return;
        }
        this.recommendWithoutTape();
      }

      answer(name) {
        const checked = this.querySelector('[data-fit-answer="' + name + '"]:checked');
        if (checked) return checked.value;
        return this.querySelector('[data-fit-answer="' + name + '"]')?.value || '';
      }

      sizeIsListed(row) {
        if (!row || !this.availableSizes.length) return true;
        const letterSize = row.size.split('/')[1]?.trim();
        return this.availableSizes.some(value => value === row.number || value === row.size || value === letterSize);
      }

      displayResult(title, paragraphs, showRestart = true) {
        const heading = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = title;
        heading.append(strong);
        this.result.replaceChildren(heading);
        paragraphs.forEach(text => {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          this.result.append(paragraph);
        });
        if (showRestart) {
          const restart = document.createElement('button');
          restart.type = 'button';
          restart.className = 'link';
          restart.dataset.fitRestart = '';
          restart.textContent = this.german ? 'Quiz erneut starten' : 'Restart the quiz';
          this.result.append(restart);
        }
        this.result.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      restartNoTapeQuiz() {
        this.querySelectorAll('[data-fit-answer]').forEach(input => {
          if (input.type === 'radio' || input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        this.result.replaceChildren();
        this.setMode('no-tape');
        this.updateStep(0);
      }

      recommendWithoutTape() {
        const baseIndex = Number(this.answer('usual-size'));
        const between = this.answer('between');
        const primary = this.answer('primary-fit');
        const secondary = this.answer('secondary-fit');
        const proportion = this.answer('proportion');
        const length = this.answer('length');
        const preference = this.answer('preference');
        const height = Number(this.answer('height'));
        let adjustment = 0;
        let uncertainty = 0;

        if (between === 'smaller') adjustment -= this.profile === 'blouse' ? .25 : .55;
        if (between === 'larger') adjustment += this.profile === 'blouse' ? .25 : .55;
        if (between === 'varies') uncertainty += 2;

        if (primary === 'tight') adjustment += this.profile === 'blouse' ? .85 : .6;
        if (primary === 'loose') adjustment -= this.profile === 'blouse' ? .85 : .6;
        if (primary === 'varies') uncertainty += 1;

        if (secondary === 'tight') adjustment += this.profile === 'blouse' ? .2 : .7;
        if (secondary === 'loose') adjustment -= this.profile === 'blouse' ? .1 : .6;
        if (secondary === 'varies') uncertainty += 1;

        if (this.profile === 'blouse') {
          if (proportion === 'narrow') adjustment -= .2;
          if (proportion === 'broad') adjustment += .25;
          if (proportion === 'unsure') uncertainty += 1;
          if ((primary === 'tight' && proportion === 'narrow') || (primary === 'loose' && proportion === 'broad')) uncertainty += 1;
        } else {
          if (proportion === 'primary') adjustment += .25;
          if (proportion === 'secondary') adjustment += .35;
          if (proportion === 'both') adjustment += .55;
          if (preference === 'closer') adjustment -= .35;
          if (preference === 'roomier') adjustment += .35;
          if ((primary === 'tight' && secondary === 'loose') || (primary === 'loose' && secondary === 'tight')) uncertainty += 1;
        }

        const boundedScore = Math.max(baseIndex - 1, Math.min(baseIndex + 1, baseIndex + adjustment));
        const suggestedIndex = Math.max(0, Math.min(Math.round(boundedScore), this.rows.length - 1));
        const baseRow = this.rows[Math.max(0, Math.min(Math.round(baseIndex), this.rows.length - 1))];
        const row = this.rows[suggestedIndex];
        const paragraphs = [];

        if (this.profile === 'blouse') {
          paragraphs.push(this.german
            ? 'Bei unseren bewusst weit geschnittenen Blusen bestimmt vor allem der Sitz an den Schultern die Größe. Brustweite und gewünschte Silhouette dienen als ergänzende Kontrolle.'
            : 'For our intentionally wide-cut blouses, the fit at the shoulders primarily determines the size. Bust room and your preferred silhouette are supporting checks.');
        } else if (suggestedIndex === Math.round(baseIndex)) {
          paragraphs.push(this.german
            ? 'Ihre übliche Konfektionsgröße und Ihre bisherigen Passformerfahrungen bestätigen diese Empfehlung.'
            : 'Your usual clothing size and previous fit experience support this recommendation.');
        } else {
          paragraphs.push(this.german
            ? 'Ausgehend von Ihrer üblichen Größe ' + baseRow.size + ' berücksichtigen wir, wo Kleidung bei Ihnen häufig enger oder weiter sitzt und welche Passform Sie bevorzugen.'
            : 'Starting from your usual size ' + baseRow.size + ', we considered where clothing often feels tighter or looser and how you prefer it to fit.');
        }

        if (this.profile === 'blouse' && preference !== 'regular') {
          paragraphs.push(this.german
            ? (preference === 'closer' ? 'Für eine körpernähere Silhouette passen wir lieber die Weite individuell an, ohne den korrekten Schultersitz zu verändern.' : 'Für eine lockerere Silhouette passen wir die Weite individuell an, ohne den korrekten Schultersitz zu verändern.')
            : (preference === 'closer' ? 'For a closer silhouette, we prefer to adjust the width individually without changing the correct shoulder fit.' : 'For a roomier silhouette, we adjust the width individually without changing the correct shoulder fit.'));
        }

        if (uncertainty >= 2) {
          paragraphs.push(this.german
            ? 'Ihre Größenangaben schwanken deutlich. Das Ergebnis ist deshalb eine erste Orientierung; für die sicherste Wahl empfehlen wir die persönliche Beratung mit Alisa.'
            : 'Your sizing varies considerably. This result is therefore an initial guide; for the most confident choice, we recommend personal advice with Alisa.');
        } else {
          paragraphs.push(this.german
            ? 'Sicherheit der Empfehlung: gute Orientierung ohne Maßband.'
            : 'Recommendation confidence: a good guide without a tape measure.');
        }

        if (length === 'short') {
          paragraphs.push(this.german
            ? (this.profile === 'blouse' ? 'Da Ärmel bei Ihnen häufig zu kurz sind, können wir die Ärmellänge individuell anpassen.' : 'Da vergleichbare Kleidungsstücke bei Ihnen häufig zu kurz sind, können wir die Länge individuell anpassen.')
            : (this.profile === 'blouse' ? 'As sleeves are often too short for you, we can adjust the sleeve length individually.' : 'As similar garments are often too short for you, we can adjust the length individually.'));
        } else if (length === 'long') {
          paragraphs.push(this.german
            ? (this.profile === 'blouse' ? 'Da Ärmel bei Ihnen häufig zu lang sind, können wir die Ärmellänge individuell anpassen.' : 'Da vergleichbare Kleidungsstücke bei Ihnen häufig zu lang sind, können wir die Länge individuell kürzen.')
            : (this.profile === 'blouse' ? 'As sleeves are often too long for you, we can adjust the sleeve length individually.' : 'As similar garments are often too long for you, we can shorten the length individually.'));
        } else if (height <= 155 || height >= 190) {
          paragraphs.push(this.german
            ? 'Aufgrund Ihrer Körpergröße empfehlen wir, die gewünschte Länge bei der Bestellung oder in einer persönlichen Beratung abzustimmen.'
            : 'Based on your height, we recommend confirming the preferred length with your order or during a personal consultation.');
        }

        if (!this.sizeIsListed(row)) {
          paragraphs.push(this.german
            ? 'Diese Größe ist bei diesem Produkt nicht direkt auswählbar. Da wir auf Bestellung fertigen, klären wir eine individuelle Lösung gerne persönlich mit Ihnen.'
            : 'This size is not directly selectable for this product. As we make each piece to order, we are happy to discuss an individual solution with you.');
        }

        this.displayResult((this.german ? 'Empfohlene Größe: ' : 'Suggested size: ') + row.size, paragraphs);
      }

      recommendMeasurements() {
        const fields = Array.from(this.quiz.querySelectorAll('[data-fit-mode="measurements"] [data-fit-measurement]'));
        for (const input of fields) if (!input.reportValidity()) return;

        if (this.profile === 'blouse') {
          const bustValue = Number(this.quiz.querySelector('[data-fit-measurement="bust"]').value);
          const shoulderValue = Number(this.quiz.querySelector('[data-fit-measurement="shoulder"]').value);
          const firstBust = this.rows[0].values.bust;
          const lastBust = this.rows[this.rows.length - 1].values.bust;
          const shoulders = this.rows.map(row => row.shoulder).filter(value => value !== null);
          if (bustValue < firstBust.min || bustValue > lastBust.max || shoulderValue < Math.min(...shoulders) - 1 || shoulderValue > Math.max(...shoulders) + 1) {
            this.displayResult(
              this.german ? 'Eine individuelle Passform könnte am besten passen.' : 'An individual fit may be best.',
              [this.german ? 'Ihre Maße liegen außerhalb unserer Standardtabelle. Wir helfen Ihnen gerne persönlich bei Ihrer Größenwahl.' : 'Your measurements fall outside our standard chart. We are happy to help you choose an individual fit.'],
              false
            );
            return;
          }
          const shoulderIndex = this.rows.reduce((bestIndex, row, index) => Math.abs(row.shoulder - shoulderValue) < Math.abs(this.rows[bestIndex].shoulder - shoulderValue) ? index : bestIndex, 0);
          const bustIndex = this.rows.findIndex(row => bustValue <= row.values.bust.max);
          const row = this.rows[shoulderIndex];
          const paragraphs = [this.german
            ? 'Die Schulterbreite bestimmt diese Empfehlung. Der Brustumfang dient bei unserer bewusst weiten Blusenform als ergänzende Kontrolle.'
            : 'The shoulder width determines this recommendation. For our intentionally roomy blouse shape, the bust measurement is used as a supporting check.'];
          if (Math.abs(shoulderIndex - bustIndex) >= 2) paragraphs.push(this.german
            ? 'Schulter- und Brustumfang weisen auf deutlich unterschiedliche Größen hin. Für den besten Sitz empfehlen wir eine kurze persönliche Beratung und können die Weite individuell anpassen.'
            : 'Your shoulder and bust measurements point to notably different sizes. For the best fit, we recommend a short personal consultation and can adjust the width individually.');
          if (!this.sizeIsListed(row)) paragraphs.push(this.german
            ? 'Diese Größe ist bei diesem Produkt nicht direkt auswählbar. Da wir auf Bestellung fertigen, klären wir eine individuelle Lösung gerne persönlich mit Ihnen.'
            : 'This size is not directly selectable for this product. As we make each piece to order, we are happy to discuss an individual solution with you.');
          this.displayResult((this.german ? 'Empfohlene Größe: ' : 'Suggested size: ') + row.size, paragraphs, false);
          return;
        }

        let suggestedIndex = 0;
        let betweenRanges = false;
        for (const input of fields) {
          const field = input.dataset.fitMeasurement;
          const value = Number(input.value);
          const first = this.rows[0].values[field];
          const last = this.rows[this.rows.length - 1].values[field];
          if (value < first.min || value > last.max) {
            this.displayResult(
              this.german ? 'Eine individuelle Passform könnte am besten passen.' : 'An individual fit may be best.',
              [this.german ? 'Ihre Maße liegen außerhalb unserer Standardtabelle. Wir helfen Ihnen gerne persönlich bei Ihrer Größenwahl.' : 'Your measurements are outside our standard chart. We are happy to help you choose an individual fit.'],
              false
            );
            return;
          }
          const index = this.rows.findIndex(row => value <= row.values[field].max);
          const minimum = this.rows[index].values[field].min;
          betweenRanges ||= minimum !== null && value < minimum;
          suggestedIndex = Math.max(suggestedIndex, index);
        }
        const row = this.rows[suggestedIndex];
        const listed = this.sizeIsListed(row);
        const paragraphs = [];
        if (listed) {
          paragraphs.push(this.german ? 'Auf Grundlage Ihrer Körpermaße ist dies unsere präziseste Größenempfehlung.' : 'Based on your body measurements, this is our most precise size recommendation.');
          if (betweenRanges) paragraphs.push(this.german ? 'Mindestens eines Ihrer Maße liegt zwischen zwei Tabellenbereichen. Die Empfehlung berücksichtigt dafür die größere Größe.' : 'At least one measurement falls between two chart ranges. The recommendation uses the larger size for that measurement.');
          const preference = this.quiz.querySelector('[data-fit-preference]').value;
          if (preference === 'closer') paragraphs.push(this.german ? 'Für Ihren Wunsch nach einem körpernäheren Sitz können wir die Passform individuell anpassen.' : 'For your preference for a closer fit, we can adjust the fit individually.');
          if (preference === 'roomier') paragraphs.push(this.german ? 'Für Ihren Wunsch nach einem lockereren Sitz können wir die Passform individuell anpassen.' : 'For your preference for a roomier fit, we can adjust the fit individually.');
        } else {
          paragraphs.push(this.german ? 'Diese Größe ist bei diesem Produkt nicht direkt auswählbar. Kontaktieren Sie uns bitte für eine individuelle Passform.' : 'This size is not directly selectable for this product. Please contact us for an individual fit.');
        }
        this.displayResult((this.german ? 'Empfohlene Größe: ' : 'Suggested size: ') + row.size, paragraphs, false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
